import type {
  ApiRegisterUserJourneyEventParams,
  ApiRegisterUserJourneyEventPort,
} from '~/handlers/ports/api-register-user-journey-event.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';

type UtmPayload = NonNullable<ApiRegisterUserJourneyEventParams['utm']>;

type GooglePayload = NonNullable<ApiRegisterUserJourneyEventParams['google']>;

type FacebookPayload = NonNullable<
  ApiRegisterUserJourneyEventParams['facebook']
>;

type TiktokPayload = NonNullable<ApiRegisterUserJourneyEventParams['tiktok']>;

type AptPayload = NonNullable<ApiRegisterUserJourneyEventParams['apt']>;

export class ApostatudoApiRegisterUserJourneyEventAdapter
  implements ApiRegisterUserJourneyEventPort
{
  async handle(params: ApiRegisterUserJourneyEventParams) {
    const payload: Record<string, unknown> = {
      action: params.event,
    };

    if (params.user?.id) {
      payload.user_id = params.user.id;
    }

    if (params.device?.fingerprint) {
      payload.device_fingerprint = params.device.fingerprint;
    }

    if (typeof params.deposit_id === 'number') {
      payload.deposit_id = params.deposit_id;
    }

    if (params.slug) {
      payload.slug = params.slug;
    }

    if (params.home_menu_item_id) {
      payload.home_menu_item_id = params.home_menu_item_id;
    }

    if (typeof params.home_menu_item_rendered_position === 'number') {
      payload.home_menu_item_rendered_position =
        params.home_menu_item_rendered_position;
    }

    const utmPayload = Object.entries(params.utm || {}).reduce(
      (acc, [key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          acc[key as keyof UtmPayload] = value;
        }

        return acc;
      },
      {} as UtmPayload,
    );

    if (Object.keys(utmPayload).length) {
      payload.utm = utmPayload;
    }

    const googlePayload = Object.entries(params.google || {}).reduce(
      (acc, [key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          acc[key as keyof GooglePayload] = value;
        }

        return acc;
      },
      {} as GooglePayload,
    );

    if (Object.keys(googlePayload).length) {
      payload.google = googlePayload;
    }

    const facebookPayload = Object.entries(params.facebook || {}).reduce(
      (acc, [key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          acc[key as keyof FacebookPayload] = value;
        }

        return acc;
      },
      {} as FacebookPayload,
    );

    if (Object.keys(facebookPayload).length) {
      payload.facebook = facebookPayload;
    }

    const tiktokPayload = Object.entries(params.tiktok || {}).reduce(
      (acc, [key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          acc[key as keyof TiktokPayload] = value;
        }

        return acc;
      },
      {} as TiktokPayload,
    );

    if (Object.keys(tiktokPayload).length) {
      payload.tiktok = tiktokPayload;
    }

    const aptPayload = Object.entries(params.apt || {}).reduce(
      (acc, [key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          acc[key as keyof AptPayload] = value;
        }

        return acc;
      },
      {} as AptPayload,
    );

    if (Object.keys(aptPayload).length) {
      payload.apt = aptPayload;
    }

    const response = await fetch(`${getApostatudoApiUrl()}/collector`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      keepalive: true,
    });

    if (!response.ok) {
      throw new Error(
        `[ApostatudoApiRegisterUserJourneyEventAdapter] APOSTATUDO API returned ${response.status}: ${response.statusText}`,
      );
    }
  }
}
